var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"highlight-toggle"},[_c('span',{staticClass:"label",class:{ highlight: _vm.isHighlighted }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('button-icon',{class:{
            active: _vm.isHighlighted,
            disabled: !_vm.isEnabled,
        },attrs:{"icon":"icon_search"},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }